import { Controller } from '@hotwired/stimulus';
import * as Highcharts from 'highcharts';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/annotations';
import 'highcharts/modules/exporting';
import 'highcharts/modules/series-label';

export default class extends Controller {
  static values = {
    config: Object,
  };

  connect() {
    this.chart = Highcharts.chart(this.element, this.configValue);
  }
}
